module.exports = "/fonts/fa-solid-900.svg?ab820b7de48566829c5e4c1d0d9993e4";